import React, { useState } from "react";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";

import '../../global.css';
import '../Theme.css';
import "./Navbar.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faHome,
    faDatabase, 
    faBell, 
    faNewspaper, 
    faCog, 
    faChartBar, 
    faBullhorn, 
    faPlus,
    faUser,
    faLifeRing,
    faAnglesRight 
} from '@fortawesome/free-solid-svg-icons';
import NotificationSideBar from "../NotificationSideBar";
import TooltipLocal from '../TooltipLocal';
import Theme from '../Theme';


const MainNavbar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState({
    services: false,
    products: false,
    technology: false,
    documentation: false,
  });
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleDropdown = (menu) => {
    setIsDropdownOpen((prevState) => ({
      ...prevState,
      [menu]: !prevState[menu],
    }));
  };

  const handleMouseEnter = (menu) => {
    if (!isMobileMenuOpen) {
      setIsDropdownOpen((prevState) => ({
        ...prevState,
        [menu]: true,
      }));
    }
  };

  const handleMouseLeave = (menu) => {
    if (!isMobileMenuOpen) {
      setIsDropdownOpen((prevState) => ({
        ...prevState,
        [menu]: false,
      }));
    }
  };

  return (
    <nav className="navbar">
        <div className="nav_logo">
            <Link to="/"><img className="logo" src="./logo.png" alt="Logo" /></Link>
        </div>
        <div className="nav_link">
                    
            {/* Mobile Menu Toggle Button */}
            <button
                className="mobile-menu-toggle"
                onClick={() => setIsMobileMenuOpen((prev) => !prev)}
            >
                {isMobileMenuOpen ? '✖' : '☰'}
            </button>

            {/* Navbar Menu */}
            <ul className={`navbar-menu ${isMobileMenuOpen ? "open" : ""}`}>
                <li>
                    <Link className="home-menu" to="/">
                        <FontAwesomeIcon icon={faHome} size="2x" color="#3498db" />
                    </Link>
                </li>
                {/* Master Dropdown */}
                <li
                    className="dropdown megamenu"
                    onMouseEnter={() => handleMouseEnter("master")}
                    onMouseLeave={() => handleMouseLeave("master")}
                >
                    <button
                        className="dropdown__toggle"
                        onClick={() => toggleDropdown("master")}
                    >
                        <FontAwesomeIcon icon={faDatabase} size="2x" color="#3498db" /> 
                        <span>Master</span>
                    </button>
                    <div
                        className={`dropdown__menu ${
                        isDropdownOpen.master ? "show" : ""
                        }`}
                    >
                        <div className="row p-3">
                            <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                                <h5 className="">Overview</h5>
                                <ul className="p-0">
                                    <li><Link href="/"> Overview 1</Link></li>
                                    <li><Link href="/"> Overview 2</Link></li>
                                    <li><Link href="/"> Overview 3</Link></li>
                                    <li><Link href="/"> Overview 4</Link></li>
                                </ul>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                                <h5 className="">Overview</h5>
                                <ul className="p-0">
                                    <li><Link href="/"> Overview 1</Link></li>
                                    <li><Link href="/"> Overview 2</Link></li>
                                    <li><Link href="/"> Overview 3</Link></li>
                                    <li><Link href="/"> Overview 4</Link></li>
                                </ul>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                                <h5 className="">Overview</h5>
                                <ul className="p-0">
                                    <li><Link href="/"> Overview 1</Link></li>
                                    <li><Link href="/"> Overview 2</Link></li>
                                    <li><Link href="/"> Overview 3</Link></li>
                                    <li><Link href="/"> Overview 4</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>

                {/* New Dropdown */}
                <li
                    className="dropdown"
                    onMouseEnter={() => handleMouseEnter("new")}
                    onMouseLeave={() => handleMouseLeave("new")}
                >
                    <button
                        className="dropdown__toggle"
                        onClick={() => toggleDropdown("new")}
                    >
                        <FontAwesomeIcon icon={faPlus} /> 
                        <span>New</span>
                    </button>
                    <ul
                        className={`dropdown__menu ${
                        isDropdownOpen.new ? "show" : ""
                        }`}
                    >
                        <li><Link href="/"> CRM Software</Link></li>
                        <li><Link href="/"> Analytics Tools</Link></li>
                        <li><Link href="/"> E-Commerce Platform</Link></li>
                    </ul>
                </li>

                {/* Components Dropdown */}
                {/* <li
                    className="dropdown"
                    onMouseEnter={() => handleMouseEnter("component")}
                    onMouseLeave={() => handleMouseLeave("component")}
                >
                    <button
                        className="dropdown__toggle"
                        onClick={() => toggleDropdown("component")}
                    >
                        <FontAwesomeIcon icon={faNewspaper} /> 
                        <span>Components</span>
                    </button>
                    <ul
                        className={`dropdown__menu custom-scroll ${
                        isDropdownOpen.component ? "show" : ""
                        }`}
                    >
                        <li><NavLink to="/button"><FontAwesomeIcon icon={faAnglesRight} /> Buttons</NavLink></li>
                        <li><NavLink to="/form"><FontAwesomeIcon icon={faAnglesRight} /> Form</NavLink></li>
                        <li><NavLink to="/table"><FontAwesomeIcon icon={faAnglesRight} /> Table</NavLink></li>
                        <li><NavLink to="/card"><FontAwesomeIcon icon={faAnglesRight} /> Card</NavLink></li>
                        <li><NavLink to="/badge"><FontAwesomeIcon icon={faAnglesRight} /> Badge</NavLink></li>
                        <li><NavLink to="/tabs"><FontAwesomeIcon icon={faAnglesRight} /> Tabs</NavLink></li>
                        <li><NavLink to="/accordion"><FontAwesomeIcon icon={faAnglesRight} /> Accordion</NavLink></li>
                        <li><NavLink to="/modal"><FontAwesomeIcon icon={faAnglesRight} /> Modal</NavLink></li>
                        <li><NavLink to="/alert"><FontAwesomeIcon icon={faAnglesRight} /> Alert</NavLink></li>
                        <li><NavLink to="/progressBar"><FontAwesomeIcon icon={faAnglesRight} /> Progress Bar</NavLink></li>
                        <li><NavLink to="/tooltip"><FontAwesomeIcon icon={faAnglesRight} /> Tooltip</NavLink></li>
                        <li><NavLink to="/fileUpload"><FontAwesomeIcon icon={faAnglesRight} /> File Upload</NavLink></li>
                        <li><NavLink to="/dropDown"><FontAwesomeIcon icon={faAnglesRight} /> Drop Down</NavLink></li>
                        <li><NavLink to="/wysiwygEditor"><FontAwesomeIcon icon={faAnglesRight} /> Wysiwyg Editor</NavLink></li>
                        <li><NavLink to="/loader"><FontAwesomeIcon icon={faAnglesRight} /> Loader</NavLink></li>
                        <li><NavLink to="/imageCropper"><FontAwesomeIcon icon={faAnglesRight} /> Image Cropper</NavLink></li>
                        <li><NavLink to="/timeline"><FontAwesomeIcon icon={faAnglesRight} /> Timeline</NavLink></li>
                        <li><NavLink to="/calendar"><FontAwesomeIcon icon={faAnglesRight} /> Calendar</NavLink></li>
                        <li><NavLink to="/countdown"><FontAwesomeIcon icon={faAnglesRight} /> Count Down</NavLink></li>
                        <li><NavLink to="/Ribbon"><FontAwesomeIcon icon={faAnglesRight} /> Ribbon</NavLink></li>
                        <li><NavLink to="/StickyElement"><FontAwesomeIcon icon={faAnglesRight} /> Sticky Elements</NavLink></li>
                        <li><NavLink to="/GuidedTour"><FontAwesomeIcon icon={faAnglesRight} /> Guided Tour</NavLink></li>
                        <li><NavLink to="/Reports"><FontAwesomeIcon icon={faAnglesRight} /> Reports</NavLink></li>
                    </ul>
                </li> */}

                <li className="nav_link_right">
                    <ul>
                        <li>
                            <Theme />
                        </li>
                        <li>
                            <Link to="/">
                                <TooltipLocal text="Setting" position="left">
                                    <FontAwesomeIcon icon={faCog} size="2x" color="#3498db" />
                                </TooltipLocal>
                            </Link>
                        </li>
                        <li>
                            <Link to="/">
                                <FontAwesomeIcon icon={faChartBar} size="2x" color="#3498db" />
                            </Link>
                        </li>
                        <li>
                            {/* <FontAwesomeIcon icon={faBell} size="2x" color="#3498db" /> */}
                            <NotificationSideBar />
                        </li>
                        <li>
                            <Link to="/">
                                <FontAwesomeIcon icon={faBullhorn} size="2x" color="#3498db" />
                            </Link>
                        </li>
                        <li>
                            <Link to="/">
                                <FontAwesomeIcon icon={faLifeRing} size="2x" color="#3498db" />
                            </Link>
                        </li>
                        {/* Profile Dropdown */}
                        <li
                            className="dropdown"
                            onMouseEnter={() => handleMouseEnter("documentation")}
                            onMouseLeave={() => handleMouseLeave("documentation")}
                        >
                            <button
                                className="dropdown__toggle"
                                onClick={() => toggleDropdown("documentation")}
                            >
                                <img className="" src="./profile.jpg" alt="Profile" /> Rohan Patil
                            </button>
                            <ul
                                className={`dropdown__menu dropdown_menu_profile ${
                                isDropdownOpen.documentation ? "show" : ""
                                }`}
                            >
                                <li><Link to="/PersonalProfile"> Profile</Link></li>
                                <li><Link to="/"> My Message</Link></li>
                                <li><Link to="/"> Config</Link></li>
                                <li><Link to="/"> Logout</Link></li>
                            </ul>
                        </li>
                        {/* Module Dropdown */}
                        <li
                            className="dropdown mob_position"
                            onMouseEnter={() => handleMouseEnter("technology")}
                            onMouseLeave={() => handleMouseLeave("technology")}
                        >
                            <button
                                className="dropdown__toggle"
                                onClick={() => toggleDropdown("technology")}
                            >
                                <img className="module-img" src="./module.png" alt="Module" />
                            </button>
                            <ul
                                className={`dropdown__menu module-dropdown ${
                                isDropdownOpen.technology ? "show" : ""
                                }`}
                            >
                                <div className="module-title text-lg">Module</div>
                                <li className="text-sm"><Link to="/"><img className="img-40" src="./purchasing.webp" alt="Module" />Purchasing</Link></li>
                                <li className="text-sm"><Link to="/"><img className="img-40" src="./purchasing.webp" alt="Module" />Stores</Link></li>
                                <li className="text-sm"><Link to="/"><img className="img-40" src="./purchasing.webp" alt="Module" />Sales</Link></li>
                                <li className="text-sm"><Link to="/"><img className="img-40" src="./purchasing.webp" alt="Module" />Accounts</Link></li>
                                <li className="text-sm"><Link to="/"><img className="img-40" src="./purchasing.webp" alt="Module" />Budget</Link></li>
                                <li className="text-sm"><Link to="/"><img className="img-40" src="./purchasing.webp" alt="Module" />Assets</Link></li>
                                <li className="text-sm"><Link to="/"><img className="img-40" src="./purchasing.webp" alt="Module" />HR</Link></li>
                                <li className="text-sm"><Link to="/"><img className="img-40" src="./purchasing.webp" alt="Module" />Payroll</Link></li>
                                <li className="text-sm"><Link to="/"><img className="img-40" src="./purchasing.webp" alt="Module" />Survey</Link></li>
                                <li className="text-sm"><Link to="/"><img className="img-40" src="./purchasing.webp" alt="Module" />Polls</Link></li>
                                <li className="text-sm"><Link to="/"><img className="img-40" src="./purchasing.webp" alt="Module" />Assessment</Link></li>
                                <li className="text-sm"><Link to="/"><img className="img-40" src="./purchasing.webp" alt="Module" />PMS</Link></li>
                                <li className="text-sm"><Link to="/"><img className="img-40" src="./purchasing.webp" alt="Module" />VMS</Link></li>
                                <li className="text-sm"><Link to="/"><img className="img-40" src="./purchasing.webp" alt="Module" />Petty Cash</Link></li>
                                <li className="text-sm"><Link to="/"><img className="img-40" src="./purchasing.webp" alt="Module" />RecruitStaq</Link></li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        
    </nav>
  );
};

export default MainNavbar;
